import React, {useEffect, useRef} from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';
import m_pin_blue from '../../../assets/img/marker/m_pin_blue.png';

/**
 * 99_3 インフラ情報（流域下水道） 管渠
 * 
 * @param spot
 * @param keyList スポットの属性のキーのうちの表示するキーを保持したリスト
 * @param latitude
 * @param longitude
 * @param option
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({spot, keyList, latitude, longitude, option, autoOpen=false}) => {

  const markerRef = useRef(null);

  useEffect(() => {

    // 変化があるごとにポップアップを自動表示
    if (autoOpen && markerRef.current) {
      markerRef.current.openPopup();
    }
  });

  let icon = menu2icon[option.id]

  if (!icon) {
    icon = m_pin_blue
  }

  const iconUrl = new L.Icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconSize: [35, 35],
    iconAnchor: [17, 23],
    popupAnchor: [0, -50]
  });

  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handleSpotData = (spot, keyList) => {

    let ret = []

    keyList.forEach(key => {
      ret.push(<dl className='dl-list is-modal-spot'><dt>{ key }</dt><dd>{spot[key]}</dd></dl>)
    })

    return ret
  }

  if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

    return (
      <>
        <Marker
          ref={markerRef}
          position={[latitude, longitude]}
          icon={iconUrl}
        >
          <Popup autoPan={false}  minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
            {
              handleSpotData(spot, keyList)
            }
          </Popup>
        </Marker>
      </>
    );
  }else{
    return null
  }
}

export default Component;
